<template>
  <div>
    <el-table :data="tableData" border style="width: 100%">
      <el-table-column prop="keywords" label="字段" width="180">
      </el-table-column>
      <el-table-column prop="content" label="内容">
        <template slot-scope="scope">
          <el-input
            v-if="scope.row.isEditPropertyShow"
            type="textarea"
            v-model="inputVal"
            placeholder=""
          ></el-input>
          <span v-else>{{ scope.row.content }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="180">
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="small"
            v-if="!scope.row.isEditPropertyShow"
            @click="handleEdit(scope.row, scope.$index)"
            >编辑</el-button
          >
          <el-button
            type="success"
            size="small"
            v-if="scope.row.isEditPropertyShow"
            @click="edit(scope.row)"
            >保存</el-button
          >
          <el-button
            type="danger"
            size="small"
            v-if="scope.row.isEditPropertyShow"
            @click="handleDelete(scope.row)"
            >取消</el-button
          >
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData: [],
      inputVal: "",
      isShow: true
    };
  },
  methods: {
    handleEdit(row, index) {
    //   console.log(row.content)
      this.inputVal = row.content
      row.isEditPropertyShow = true
      //   this.$set(this.tableData[index], 'isEditPropertyShow', true)
    },
    async edit(row) {
    //   console.log(row)
      const res = await this.$axios.post("/api/KeyswordsUpdate",{
        id:row.id,
        content:this.inputVal
      })
      res.data = JSON.parse(res.data)
    //   console.log(res.data)
      if (res.data.code === 0) {
        this.$message({
          message: res.data.msg,
          type: "success"
        })
        this.getList()
        row.isEditPropertyShow = false
      }
    },
    handleDelete(row) {
      //   console.log(row)
      row.isEditPropertyShow = false;
      this.inputVal = "";
    },
    async getList() {
      const dt = await this.$axios.post("/api/keyswords")
      dt.data = JSON.parse(dt.data)
    //   console.log(dt.data);
      if (dt.data.code === 0) {
        this.tableData = dt.data.data.map(obj => ({
          ...obj,
          isEditPropertyShow: false
        }))
      }
    }
  },
  mounted() {
    this.getList();
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/admin/keywords.vue